import { DateRangePreset } from './types'
import {
  getEndOfMonth,
  getStartOfMonth,
  getEndOfDay,
  getStartOfDay,
  getEndOfYear,
  getStartOfYear,
} from '../utils/dateUtils'

export const dateRangeFilterPresets: Record<string, DateRangePreset & { isDefault?: boolean }> = {
  'last-7-days': {
    label: 'Last 7 Days',
    apply: () => {
      const now = new Date()
      const start = new Date(now)
      start.setDate(start.getDate() - 7)

      return {
        startDate: getStartOfDay(start),
        endDate: getEndOfDay(now),
      }
    },
    isDefault: true,
  },

  'month-to-date': {
    label: 'Month to Date',
    apply: () => {
      const now = new Date()
      return {
        startDate: getStartOfMonth(now),
        endDate: getEndOfDay(now),
      }
    },
    isDefault: true,
  },

  'last-30-days': {
    label: 'Last 30 Days',
    apply: () => {
      const now = new Date()
      const start = new Date(now)
      start.setDate(start.getDate() - 30)

      return {
        startDate: getStartOfDay(start),
        endDate: getEndOfDay(now),
      }
    },
  },

  'last-month': {
    label: 'Last Month',
    apply: () => {
      const now = new Date()
      const lastMonth = new Date(now)
      lastMonth.setMonth(lastMonth.getMonth() - 1)

      return {
        startDate: getStartOfMonth(lastMonth),
        endDate: getEndOfMonth(lastMonth),
      }
    },
    isDefault: true,
  },

  'last-3-months': {
    label: 'Last 3 Months',
    apply: () => {
      const now = new Date()
      const start = new Date(now)
      start.setMonth(start.getMonth() - 3)

      return {
        startDate: getStartOfMonth(start),
        endDate: getEndOfMonth(now),
      }
    },
    isDefault: true,
  },

  'last-year': {
    label: 'Last Year',
    apply: () => {
      const now = new Date()
      const lastYear = new Date(now)
      lastYear.setFullYear(lastYear.getFullYear() - 1)

      return {
        startDate: getStartOfYear(lastYear),
        endDate: getEndOfYear(lastYear),
      }
    },
  },

  'year-to-date': {
    label: 'Year to Date',
    apply: () => {
      const now = new Date()
      return {
        startDate: getStartOfYear(now),
        endDate: getEndOfDay(now),
      }
    },
    isDefault: true,
  },
} as const

export const getDefaultDateRangePreset = (): DateRangePreset[] => {
  return Object.values(dateRangeFilterPresets).filter((preset) => preset.isDefault)
}

export const isPresetSelected = (preset: DateRangePreset, [startDate, endDate]: [string, string]) => {
  const { startDate: presetStartDate, endDate: presetEndDate } = preset.apply()
  return startDate === presetStartDate.toISOString() && endDate === presetEndDate.toISOString()
}
